import { HTTP } from "@/api";

export default {
  getStatistic(_, params = {}) {
    return HTTP.get("/v2/forecast/statistic", { params })
  }
};
